export class ICESTotal {
    public Total: number;
    public Year: number;

    constructor(
        public ICES: string
    ) {
        this.Total = 0;
    }
}